<template>
  <div class="table-container">
    <export-options
      :exportUrl="exportUrl"
      :repository="repository"
      :resource="resource"
      :tableRef="$refs[tableRef]"
      :filter="filter"
      :options="[
        {
          code: 'EXPOCLAI',
          label: null,
          formats: ['csv', 'pdf'],
        },
      ]"
    ></export-options>
    <table-claims
      :isTableInModal="true"
      :fields="fields"
      :repository="repository"
      :resource="resource"
      :filterName="filterName"
      :ref="tableRef"
      class="mt-2"
      noActions
      noInnerWidth
      noInputPaginator
    >
    </table-claims>
  </div>
</template>

<script>
import TableClaims from "@/components/tables/Claims";
import ExportOptions from "@/components/ExportOptions";
import { toLocaleCurrency } from "@/utils/strings";
import DetailTabAutofetchTableMixin from "@/mixins/DetailTabAutofetchTableMixin";

export default {
  mixins: [DetailTabAutofetchTableMixin],
  name: "Claims",
  data() {
    return {
      exportUrl: null,
      filter: this.initFilter(),
      filterName: "filterClaimDetail",
      repository: "claim",
      resource: "claims",
      tableRef: "ClaimTableRef",
      items: [],
      fields: [
        {
          label: this.getDictionary("number", "claim"),
          key: "claim_number",
          value: (item) =>
            this.joinValues([
              item.insurance_policy && item.insurance_policy.insurer
                ? item.insurance_policy.insurer.code
                : null,
              item.insurance_policy && item.insurance_policy.insurer
                ? // ? this.$store.state.auth.mandate_codes.find(
                  //     (e) => e.id === item.insurance_policy.mandate_code_id
                  //   ).code
                this.findAndGet(
                  this.$store.state.auth.mandate_codes,
                  "id",
                  item.insurance_policy.mandate_code_id,
                  "code"
                )
                : null,
              item.referring_at,
              item.number,
            ]),
          sortable: true,
          sortKey: "number",
        },
        {
          key: "surveyor",
          label: this.getDictionary("surveyor", "claim"),
          sortable: false,
          sortKey: "byAttribute.surveyor",
        },
        {
          key: "settlement_expense",
          label: this.getDictionary("settlement_expense", "claim"),
          sortable: true,
          sortKey: "byAttribute.settlement_expense",
          formatter: (value) => toLocaleCurrency(value),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
      ],
    };
  },
  components: {
    TableClaims,
    ExportOptions,
  },
  props: {
    resourceId: Number,
  },
  methods: {
    initFilter() {
      let init = {
        byInsurancePolicy: { id: this.resourceId },
      };
      return init;
    },
    onSearch(name) {
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName
      );
    },
  },
  beforeMount() {
    this.saveFilterByName({ name: this.filterName, criteria: this.filter });
  },
  mounted() {
    this.onSearch(this.filterName);
  },
};
</script>
